// extracted by mini-css-extract-plugin
module.exports = {"areaStudyData":"index-areaStudyData-1l78z","chartTitle":"index-chartTitle-19VFV"};